import { render, staticRenderFns } from "./InfosetsDropdownMenu.vue?vue&type=template&id=5b138e2c&"
import script from "./InfosetsDropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./InfosetsDropdownMenu.vue?vue&type=script&lang=ts&"
import style0 from "./InfosetsDropdownMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports